
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    relativeTo: {
      type: String,
      required: false,
      default: "body",
    },
  },
  setup(props) {
    const iconType = computed(() => {
      switch (props.type) {
        case "success":
          return "success";
        case "warn":
          return "warning";
        case "info":
          return "info";
      }
    });

    return {
      iconType,
    };
  },
});
